import { useCallback } from "react";
import { calculateHandymanServiceCost } from "../api/handyman/handyman-service-api";
import { applyAdditionalDiscount } from "./ac-apply-additional-discount";

export const handymanCostCalculator = (
    requestCriteria, 
    serviceDate, 
    startTime, 
    endTime,
    setServicingCost, 
    setRateAggregatorFactor, 
    setServiceSummary, 
    setServiceType, 
    setTotalDiscountPercent, 
    setOriginalCost,
    setBookingFee,
    setIsLoading,
    setErrorContent,
    setIsSystemError
) => {
    return useCallback(async () => {
        if (requestCriteria.length === 0 || !serviceDate || !startTime || !endTime) return;
        try {
            setIsLoading(true)
            const response = await calculateHandymanServiceCost(JSON.stringify(requestCriteria), serviceDate, startTime, endTime);
            setTotalDiscountPercent(response.discountPercent)
            setOriginalCost(response.serviceCost)
            const serviceCost = response.serviceCost - response.serviceCost * response.discountPercent / 100;
            // serviceCost = applyAdditionalDiscount(serviceCost);
            setServicingCost(serviceCost.toFixed(2))          
            setBookingFee(response.bookingFee)
            setServiceSummary(response.serviceSummary)
            setServiceType(response.serviceType)

            if (response.rateAggregatorFactor) {
                setRateAggregatorFactor(response.rateAggregatorFactor);
            } else {
                setRateAggregatorFactor("");
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            setErrorContent({'header': "Error calculating charges", 'body': "Please reload the app and try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true)  
        }
    }, [requestCriteria, serviceDate, startTime, endTime, setServicingCost, setRateAggregatorFactor]);
}